var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _path0, _path1, _circle11, _path10, _path11, _path12, _path13, _path14, _path15, _circle12, _circle13, _circle14, _circle15, _path16, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _ellipse, _rect, _rect2, _circle32, _circle33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f38d0f94-23a8-43eb-bb93-93e646a606c4",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 728,
    height: 728,
    viewBox: "0 0 728 728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b4bc5a12-d6f7-4a10-a970-041eb55f3dba",
    x1: 266.72136,
    y1: 350.67626,
    x2: 266.72136,
    y2: 320.44576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae34416f-00d0-4d82-8898-13bc62cda4de",
    x1: 540.72136,
    y1: 246.67626,
    x2: 540.72136,
    y2: 216.44576,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bde9d0e3-086e-46a5-9e57-bf92b8f5f234",
    x1: 817.72136,
    y1: 293.67626,
    x2: 817.72136,
    y2: 263.44576,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e5c97b0b-d48e-4d7a-8016-8b86435e36e1",
    x1: 361.87132,
    y1: 329.59761,
    x2: 361.87132,
    y2: 305.82432,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b7d08f71-43f4-4095-96c9-baffa43401dc",
    x1: 711.87132,
    y1: 272.59761,
    x2: 711.87132,
    y2: 248.82432,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd97b392-9aa7-4641-a6bd-725bd7d7b3ea",
    x1: 212.28757,
    y1: 154.96931,
    x2: 212.28757,
    y2: 142.82631,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab242aa7-1e8a-4fd9-95e1-036c1d8cfb39",
    x1: 213.28757,
    y1: 230.96931,
    x2: 213.28757,
    y2: 218.82631,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acf55f84-2ff0-4661-973d-4119980e8f20",
    x1: 532.28757,
    y1: 138.96931,
    x2: 532.28757,
    y2: 126.82631,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e392fd56-72db-404c-ac12-80f62311fe79",
    x1: 671.28757,
    y1: 246.96931,
    x2: 671.28757,
    y2: 234.82631,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a46793a6-8246-4f43-a66c-aed8341e26e7",
    x1: 634.53757,
    y1: 241.44685,
    x2: 634.53757,
    y2: 222.84878,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7927ba0-d558-4723-9031-baaf232641ce",
    x1: 499.53757,
    y1: 258.44685,
    x2: 499.53757,
    y2: 239.84878,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f982fd36-4051-48fb-a2e1-9a6411673f03",
    x1: 414.53757,
    y1: 159.44685,
    x2: 414.53757,
    y2: 140.84878,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b3a76323-2446-4deb-97ae-598e028debf8",
    x1: 305.53757,
    y1: 213.44685,
    x2: 305.53757,
    y2: 194.84878,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e8208f6a-bbdd-4349-9414-f8993ce71372",
    x1: 116.53757,
    y1: 173.44685,
    x2: 116.53757,
    y2: 154.84878,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab778f5f-949d-41ad-be50-420f48bd634e",
    x1: 83.53757,
    y1: 332.44685,
    x2: 83.53757,
    y2: 313.84878,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a0f4e28c-8c99-44cf-a4be-c2a5344d6d11",
    x1: 606.05841,
    y1: 138.50804,
    x2: 606.05841,
    y2: 128.45638,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "afffbbaf-5aff-400b-a5c4-b8b5c923de1d",
    x1: 342.05841,
    y1: 266.50804,
    x2: 342.05841,
    y2: 256.45638,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f7e49974-8afd-4091-abd4-7aabcd1b0071",
    x1: 55.05841,
    y1: 195.50804,
    x2: 55.05841,
    y2: 185.45638,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb03fb0f-bdf6-44b2-8f81-e92a2a453cde",
    x1: 120.05841,
    y1: 322.50804,
    x2: 120.05841,
    y2: 312.45638,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bac93885-8e57-4c9e-9b9d-56bf7bd46f01",
    x1: 234.05841,
    y1: 305.50804,
    x2: 234.05841,
    y2: 295.45638,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a1705377-2f9f-4436-b0f8-d595ef03a295",
    x1: 399.05841,
    y1: 226.50804,
    x2: 399.05841,
    y2: 216.45638,
    xlinkHref: "#b4bc5a12-d6f7-4a10-a970-041eb55f3dba"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Astronaut") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M964,450a365.93891,365.93891,0,0,1-4.81,59.32c-.26,1.62-.54,3.24-.83,4.86-20.84,117.17-97.75,214.96-202,264.62-.5.24-1.01.48-1.52.72q-6.105,2.88006-12.35,5.54c-1.12.47-2.23.94-3.36,1.4a361.01375,361.01375,0,0,1-69.93,20.97c-1.06.21-2.12.4-3.18.59A365.28336,365.28336,0,0,1,600.27,814h-1.01c-1.96,0-3.92-.02-5.87-.07-.37,0-.74,0-1.11-.02a365.11618,365.11618,0,0,1-65.44-7.26c-1.05-.22-2.1-.44-3.15-.67a359.57911,359.57911,0,0,1-56.82-17.1c-1.13-.43-2.24-.88-3.36-1.34q-6.24-2.505-12.35-5.26c-.51-.23-1.02-.46-1.52-.69-107.29-48.73-186.76-148-208-267.41-.29-1.62-.57-3.24-.83-4.86a368.10114,368.10114,0,0,1-.04-118.38c.36-2.25.75-4.51,1.17-6.75a358.92008,358.92008,0,0,1,11.7-46.44q.75-2.325,1.53-4.65C303.87,189.42,439.86,86,600,86c178.56,0,327.09,128.58,358.06,298.19.42,2.24.81,4.5,1.17,6.75A366.12008,366.12008,0,0,1,964,450Z",
    transform: "translate(-236 -86)",
    fill: "#13d9fd",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M546.89405,229.18948h-1.9415c-.39542,0-1.37331-1.552-1.37331-1.99734v-1.80383c0-1.40763-1.59234-5.26934-3-5.26934s-3,3.86171-3,5.26934v1.80383c0,.63468-.49,1.99734-1.08908,1.99734h-1.9415c-1.40768,0-5.26934,1.09234-5.26934,2.5s3.86166,2.5,5.26934,2.5h2.31548c.73323,0,.7151.75422.7151,1.13821v2.406c0,1.40769,1.59234,5.26934,3,5.26934s3-3.86165,3-5.26934v-2.406c0-.31878.64377-1.13821.99934-1.13821h2.31547c1.40763,0,5.26934-1.09228,5.26934-2.5S548.30168,229.18948,546.89405,229.18948Z",
    transform: "translate(-236 -86)",
    fill: "#2196f3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M274.87565,332.42815h-2.56477c-.52236,0-1.81418-2.05026-1.81418-2.63854v-2.3829c0-1.85952-2.10353-6.96095-3.96312-6.96095s-3.963,5.10143-3.963,6.96095v2.3829c0,.83843-.64729,2.63854-1.4387,2.63854h-2.56477c-1.8596,0-6.961,1.443-6.961,3.30261s5.10135,3.30253,6.961,3.30253h3.0588c.96862,0,.94467.99635.94467,1.50362v3.17839c0,1.8596,2.10353,6.961,3.963,6.961s3.96312-5.10136,3.96312-6.961v-3.17839c0-.42113.85044-1.50362,1.32015-1.50362h3.0588c1.85953,0,6.961-1.44294,6.961-3.30253S276.73518,332.42815,274.87565,332.42815Z",
    transform: "translate(-236 -86)",
    fill: "url(#b4bc5a12-d6f7-4a10-a970-041eb55f3dba)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M548.87565,228.42815h-2.56477c-.52236,0-1.81418-2.05026-1.81418-2.63854v-2.3829c0-1.85952-2.10353-6.96095-3.96312-6.96095s-3.96305,5.10143-3.96305,6.96095v2.3829c0,.83843-.64729,2.63854-1.4387,2.63854h-2.56477c-1.8596,0-6.961,1.443-6.961,3.30261s5.10135,3.30253,6.961,3.30253h3.0588c.96862,0,.94467.99635.94467,1.50362v3.17839c0,1.8596,2.10353,6.961,3.96305,6.961s3.96312-5.10136,3.96312-6.961v-3.17839c0-.42113.85044-1.50362,1.32015-1.50362h3.0588c1.85953,0,6.961-1.44294,6.961-3.30253S550.73518,228.42815,548.87565,228.42815Z",
    transform: "translate(-236 -86)",
    fill: "url(#ae34416f-00d0-4d82-8898-13bc62cda4de)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M825.87565,275.42815h-2.56477c-.52236,0-1.81418-2.05026-1.81418-2.63854v-2.3829c0-1.85952-2.10353-6.96095-3.96312-6.96095s-3.96305,5.10143-3.96305,6.96095v2.3829c0,.83843-.64729,2.63854-1.4387,2.63854h-2.56477c-1.8596,0-6.961,1.443-6.961,3.30261s5.10135,3.30253,6.961,3.30253h3.0588c.96862,0,.94467.99635.94467,1.50362v3.17839c0,1.8596,2.10353,6.961,3.96305,6.961s3.96312-5.10136,3.96312-6.961v-3.17839c0-.42113.85044-1.50362,1.32015-1.50362h3.0588c1.85953,0,6.961-1.44294,6.961-3.30253S827.73518,275.42815,825.87565,275.42815Z",
    transform: "translate(-236 -86)",
    fill: "url(#bde9d0e3-086e-46a5-9e57-bf92b8f5f234)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M715.80521,259.18948h-1.23733c-.252,0-.98864-.979-.98864-1.26282v-1.14959c0-.89709-1.10289-3.35818-2-3.35818s-2,2.46109-2,3.35818v1.14959c0,.40449-.02269,1.26282-.40449,1.26282h-1.23733c-.89712,0-3.35818.60289-3.35818,1.5s2.46106,1.5,3.35818,1.5h1.47567c.46729,0,.16615.6773.16615.922v1.53336c0,.89713,1.10289,3.35818,2,3.35818s2-2.461,2-3.35818V263.1115c0-.20317.5237-.922.7503-.922h1.47567c.89709,0,3.35818-.60286,3.35818-1.5S716.7023,259.18948,715.80521,259.18948Z",
    transform: "translate(-236 -86)",
    fill: "#1976d2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M368.28386,315.23083h-2.01693c-.41079,0-1.61157-1.59587-1.61157-2.05849v-1.87392c0-1.46233-1.79779-5.4741-3.26018-5.4741s-3.26013,4.01177-3.26013,5.4741v1.87392c0,.65933-.037,2.05849-.65934,2.05849h-2.01694c-1.46239,0-5.4741.98275-5.4741,2.44514s4.01171,2.44509,5.4741,2.44509h2.40544c.76173,0,.27084,1.104.27084,1.503v2.49949c0,1.46239,1.7978,5.4741,3.26013,5.4741s3.26018-4.01171,3.26018-5.4741V321.624c0-.33117.85368-1.503,1.22306-1.503h2.40544c1.46233,0,5.4741-.9827,5.4741-2.44509S369.74619,315.23083,368.28386,315.23083Z",
    transform: "translate(-236 -86)",
    fill: "url(#e5c97b0b-d48e-4d7a-8016-8b86435e36e1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M718.28386,258.23083h-2.01693c-.41079,0-1.61157-1.59587-1.61157-2.05849v-1.87392c0-1.46233-1.79779-5.4741-3.26018-5.4741s-3.26013,4.01177-3.26013,5.4741v1.87392c0,.65933-.037,2.05849-.65934,2.05849h-2.01694c-1.46239,0-5.4741.98275-5.4741,2.44514s4.01171,2.44509,5.4741,2.44509h2.40544c.76173,0,.27084,1.104.27084,1.503v2.49949c0,1.46239,1.7978,5.4741,3.26013,5.4741s3.26018-4.01171,3.26018-5.4741V264.624c0-.33117.85368-1.503,1.22306-1.503h2.40544c1.46233,0,5.4741-.9827,5.4741-2.44509S719.74619,258.23083,718.28386,258.23083Z",
    transform: "translate(-236 -86)",
    fill: "url(#b7d08f71-43f4-4095-96c9-baffa43401dc)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M365.80521,316.18948h-1.23733c-.252,0-.98864-.979-.98864-1.26282v-1.14959c0-.89709-1.10289-3.35818-2-3.35818s-2,2.46109-2,3.35818v1.14959c0,.40449-.02269,1.26282-.40449,1.26282h-1.23733c-.89712,0-3.35818.60289-3.35818,1.5s2.46106,1.5,3.35818,1.5h1.47567c.46729,0,.16615.6773.16615.922v1.53336c0,.89713,1.10289,3.35818,2,3.35818s2-2.461,2-3.35818V320.1115c0-.20317.5237-.922.7503-.922h1.47567c.89709,0,3.35818-.60286,3.35818-1.5S366.7023,316.18948,365.80521,316.18948Z",
    transform: "translate(-236 -86)",
    fill: "#1976d2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 414.07924,
    cy: 149.68948,
    r: 7.5,
    fill: "#64b5f6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.07924,
    cy: 221.02281,
    r: 2.5,
    fill: "#0071bc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.53757,
    cy: 164.14781,
    r: 6.95833,
    fill: "#64b5f6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.05841,
    cy: 190.48221,
    r: 3.47917,
    fill: "#64b5f6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 342.05841,
    cy: 261.48221,
    r: 3.47917,
    fill: "#82a9ff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.37132,
    cy: 323.60615,
    r: 6.5,
    fill: "#82a9ff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.28757,
    cy: 148.89781,
    r: 6.0715,
    fill: "url(#bd97b392-9aa7-4641-a6bd-725bd7d7b3ea)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.28757,
    cy: 224.89781,
    r: 6.0715,
    fill: "url(#ab242aa7-1e8a-4fd9-95e1-036c1d8cfb39)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.28757,
    cy: 132.89781,
    r: 6.0715,
    fill: "url(#acf55f84-2ff0-4661-973d-4119980e8f20)"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.28757,
    cy: 240.89781,
    r: 6.0715,
    fill: "url(#e392fd56-72db-404c-ac12-80f62311fe79)"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.28757,
    cy: 148.89781,
    r: 3.70833,
    fill: "#0d47a1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.07924,
    cy: 203.68948,
    r: 7.5,
    fill: "#64b5f6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M762.87,605.58c-.24,8.8-3.1,17.21-6.51,25.38-.5,1.2-1.01,2.39-1.52,3.57q-.795,1.8-1.59,3.6c-2.78,6.28-5.62,12.65-10,17.94-.25.3-.5.6-.76.88995a31.23944,31.23944,0,0,1-3.36,3.25,22.98444,22.98444,0,0,1-13.35,5.67c-9.54.5-17.81006-6.15-25.03-12.42Q687.835,642.27,674.92,631.05c-2.96-2.56-10.13995-8.79-10.77-9.34V743.97h-2.21l1.32,20.71,2.76,43.34A365.28336,365.28336,0,0,1,600.27,814l-1.82-49.25-.52-14.03-.25-6.75h-2.06l-.18,3.67-.81,17.11-2.35,49.16a365.11618,365.11618,0,0,1-65.44-7.26l2.61-41.91,1.3-20.77h-1.29V619.73a108.31994,108.31994,0,0,1-12.72,14.04c-9.06,8.5-19.38,15.89-29.53,23.09-6.16,4.37-13.17,8.88-20.34,10.61a26.28086,26.28086,0,0,1-3.36.59,20.40066,20.40066,0,0,1-9.35-1.01,18.63,18.63,0,0,1-3-1.38c-.53-.29-1.03-.6-1.52-.93-7.49-5.11-11.43-14.91-14.52-23.82-3.74-10.8-7.54-22.11-5.95-33.43.97-6.85,3.83-13.14,7.41-19.11,2.43-4.05,5.19-7.95,7.92-11.77,1.31-1.83,2.89-3.81,4.98-4.37h.01l.15-.03a3.97151,3.97151,0,0,1,.77-.11,6.14461,6.14461,0,0,1,.75.02c2.09.25,3.86005,1.92,5.37006,3.47q3.49494,3.6,6.98,7.19,1.68,1.725,3.36,3.45c.18.19.36.38.55.57,1.48,1.52,2.95,3.04,4.43,4.56,2.89-4.99,5.8-10.01,8.87-14.92,6.24-10,13.14-19.54,21.81006-27.47a72.41155,72.41155,0,0,1,14.21-10.2,59.70615,59.70615,0,0,1,14.13-5.59c5.68-1.42,9.91-2.07,12.81-1.05,2.28.8,3.74,2.65,4.43,5.98a.29562.29562,0,0,1,.02.1,27.97376,27.97376,0,0,1,.46,5.35c0,1.11,0,2.22-.01,3.34H643.6c-.09-2.88-.17-6.04-.02-8.69.03-.63995.08-1.25.13995-1.82a7.54644,7.54644,0,0,1,1.08-3.73,4.727,4.727,0,0,1,3.69-1.38c4.38-.06,10.71,2.85,13.81,4.01a90.92607,90.92607,0,0,1,12.62,5.88c19.54,10.94,35.22,28.95,42.42,50.22a19.55213,19.55213,0,0,1,3.7-7.21,22.33029,22.33029,0,0,1,3.97-3.86,24.34769,24.34769,0,0,1,7.94-4,22.42637,22.42637,0,0,1,6.18-.95,19.83181,19.83181,0,0,1,3.36.22,18.985,18.985,0,0,1,5.21,1.53,22.57869,22.57869,0,0,1,7.14,5.24c.54.58,1.04,1.18,1.52,1.8a32.14374,32.14374,0,0,1,5.92,13.85A35.798,35.798,0,0,1,762.87,605.58Z",
    transform: "translate(-236 -86)",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M655.22259,462.53564h0c-7.53717-26.65347-30.98946-48.20579-58.76951-48.20579s-51.23224,21.55232-58.76941,48.20579h0a12.47581,12.47581,0,0,0-12.47581,12.47581V490.183h10.67278c4.59617,28.99046,29.96238,48.20579,60.57245,48.20579s55.97638-19.21533,60.57255-48.20579h10.99519V475.33386A12.79822,12.79822,0,0,0,655.22259,462.53564Z",
    transform: "translate(-236 -86)",
    fill: "#fff"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 360.09866,
    cy: 394.96727,
    r: 49.6236,
    fill: "#13d9fd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M759.5,377.64a11.08,11.08,0,0,1-2.13,6.55,10.90865,10.90865,0,0,1-2.44,2.45.54836.54836,0,0,1-.09.07V779.52q-6.105,2.88006-12.35,5.54V387.14a11.15863,11.15863,0,1,1,17.01-9.5Z",
    transform: "translate(-236 -86)",
    fill: "#e0e0e0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M964,450c0,20.23853-1.63953,37.08844-4.81,51.70471C891.10327,401.64618,823.0166,624.9765,754.93,509.32V390.94c68.09992,115.67911,136.2-107.76126,204.29993-7.55652A519.22316,519.22316,0,0,1,964,450Z",
    transform: "translate(-236 -86)",
    fill: "#13d9fd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M468.83,377.64a11.02338,11.02338,0,0,1-3.77,8.34,10.26417,10.26417,0,0,1-1.55,1.16v400.4q-6.24-2.505-12.35-5.26V386.71a.54836.54836,0,0,1-.09-.07,10.90865,10.90865,0,0,1-2.44-2.45,11.16148,11.16148,0,1,1,20.2-6.55Z",
    transform: "translate(-236 -86)",
    fill: "#e0e0e0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M451.07,390.94q0,59.19008,0,118.38c-70.08667-115.73239-140.17334,107.96753-210.26,7.41766A515.22882,515.22882,0,0,1,236,450c0-20.14563,1.62994-37.02295,4.77-51.69971C310.87,498.99252,380.97,275.18552,451.07,390.94Z",
    transform: "translate(-236 -86)",
    fill: "#13d9fd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M602.363,442.30623a49.54182,49.54182,0,0,1,39.61707,19.74459,49.625,49.625,0,1,0-85.49848,48.79537,49.63307,49.63307,0,0,1,45.88141-68.54Z",
    transform: "translate(-236 -86)",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M419.39405,340.18948h-1.9415c-.39542,0-1.37331-1.552-1.37331-1.99734v-1.80383c0-1.40763-1.59234-5.26934-3-5.26934s-3,3.86171-3,5.26934v1.80383c0,.63468-.49,1.99734-1.08908,1.99734h-1.9415c-1.40768,0-5.26934,1.09234-5.26934,2.5s3.86166,2.5,5.26934,2.5h2.31548c.73323,0,.7151.75422.7151,1.13821v2.406c0,1.40769,1.59234,5.26934,3,5.26934s3-3.86165,3-5.26934v-2.406c0-.31878.64377-1.13821.99934-1.13821h2.31547c1.40763,0,5.26934-1.09228,5.26934-2.5S420.80168,340.18948,419.39405,340.18948Z",
    transform: "translate(-236 -86)",
    fill: "#2196f3"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.57924,
    cy: 324.02279,
    r: 3.5,
    fill: "#0d47a1"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 646.03757,
    cy: 256.14781,
    r: 6.95833,
    fill: "#64b5f6"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.57924,
    cy: 307.02281,
    r: 2.5,
    fill: "#0071bc"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.28757,
    cy: 224.89781,
    r: 3.70833,
    fill: "#0d47a1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M823.89405,276.18948h-1.9415c-.39542,0-1.37331-1.552-1.37331-1.99734v-1.80383c0-1.40763-1.59234-5.26934-3-5.26934s-3,3.86171-3,5.26934v1.80383c0,.63468-.49,1.99734-1.08908,1.99734h-1.9415c-1.40768,0-5.26934,1.09234-5.26934,2.5s3.86166,2.5,5.26934,2.5h2.31548c.73323,0,.7151.75422.7151,1.13821v2.406c0,1.40769,1.59234,5.26934,3,5.26934s3-3.86165,3-5.26934v-2.406c0-.31878.64377-1.13821.99934-1.13821h2.31547c1.40763,0,5.26934-1.09228,5.26934-2.5S825.30168,276.18948,823.89405,276.18948Z",
    transform: "translate(-236 -86)",
    fill: "#2196f3"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.07924,
    cy: 240.02279,
    r: 3.5,
    fill: "#0d47a1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.07924,
    cy: 133.02279,
    r: 3.5,
    fill: "#0d47a1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 634.53757,
    cy: 232.14781,
    r: 9.29903,
    fill: "url(#a46793a6-8246-4f43-a66c-aed8341e26e7)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.53757,
    cy: 249.14781,
    r: 9.29903,
    fill: "url(#e7927ba0-d558-4723-9031-baaf232641ce)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.53757,
    cy: 150.14781,
    r: 9.29903,
    fill: "url(#f982fd36-4051-48fb-a2e1-9a6411673f03)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.53757,
    cy: 204.14781,
    r: 9.29903,
    fill: "url(#b3a76323-2446-4deb-97ae-598e028debf8)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.53757,
    cy: 164.14781,
    r: 9.29903,
    fill: "url(#e8208f6a-bbdd-4349-9414-f8993ce71372)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.53757,
    cy: 323.14781,
    r: 9.29903,
    fill: "url(#ab778f5f-949d-41ad-be50-420f48bd634e)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.05841,
    cy: 133.48221,
    r: 5.02583,
    fill: "url(#a0f4e28c-8c99-44cf-a4be-c2a5344d6d11)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 342.05841,
    cy: 261.48221,
    r: 5.02583,
    fill: "url(#afffbbaf-5aff-400b-a5c4-b8b5c923de1d)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.05841,
    cy: 190.48221,
    r: 5.02583,
    fill: "url(#f7e49974-8afd-4091-abd4-7aabcd1b0071)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.05841,
    cy: 317.48221,
    r: 5.02583,
    fill: "url(#bb03fb0f-bdf6-44b2-8f81-e92a2a453cde)"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.05841,
    cy: 300.48221,
    r: 5.02583,
    fill: "url(#bac93885-8e57-4c9e-9b9d-56bf7bd46f01)"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.05841,
    cy: 221.48221,
    r: 5.02583,
    fill: "url(#a1705377-2f9f-4436-b0f8-d595ef03a295)"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.05841,
    cy: 133.48221,
    r: 3.47917,
    fill: "#82a9ff"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 634.37132,
    cy: 232.60615,
    r: 6.5,
    fill: "#64b5f6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 358,
    cy: 415,
    rx: 29,
    ry: 5,
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 325,
    y: 287,
    width: 4,
    height: 63,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 292,
    width: 4,
    height: 63,
    fill: "#fff"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 327,
    cy: 287,
    r: 10,
    fill: "#fff"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 287,
    r: 10,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5ebd04010dc620ef40180d59d67711f8.svg";
export { ForwardRef as ReactComponent };